import ouiBase from '@goldwasserexchange/oui';
import { useBondSameIssuerFieldApiBySAccId } from '../api';

export const useBondSameIssuerSIssuerName1 = () => {
  const sAccId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useBondSameIssuerFieldApiBySAccId({
    sAccId,
    field: 'S_ISSUER.NAME_1',
  });
  return response;
};
